<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{'schedule.add-new-title' | translate}}</h4>
    <button type="button" class="close pull-right" [attr.aria-label]="'modal.close' | translate" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="recordingForm" (ngSubmit)="onSubmit()">
      <div class="mt-4 form-group">
        <label>{{ 'schedule.team' | translate }}</label>
        <label class="w-100">
          <ng-select appearance="outline" [searchable]="isAdmin" formControlName="team">
            @for (team of teams; track team) {
              <ng-option [value]="team.path">{{team.name}}
              </ng-option>
            }
          </ng-select>
          @if (recordingForm.get('team').errors?.required && submitted) {
            <div class="invalid-tooltip">
            {{ 'schedule.team' | translate }} {{ 'is-required' | translate }}</div>
          }
        </label>
      </div>
      <div class="mt-4 form-group">
        <label>{{ 'schedule.recordingSetup' | translate }}</label>&nbsp;
        <button type="button" class="btn btn-link btn-sm p-0" [attr.aria-expanded]="showSetupPreview" (click)="showSetupPreview = !showSetupPreview">
          <i class="simple-icon-eye mr-1"></i>{{ 'setupPreview.toggle' | translate }}
          <i class="ml-1" [class.simple-icon-arrow-up]="showSetupPreview" [class.simple-icon-arrow-down]="!showSetupPreview"></i>
        </button>
        <label class="w-100">
          <ng-select appearance="outline" [items]="recordingSetups" [searchable]="true" [loading]="recordingSetupsLoading" bindValue="v" bindLabel="d" formControlName="recordingSetup">
          </ng-select>
          @if (recordingForm.get('recordingSetup').errors?.required && submitted) {
            <div class="invalid-tooltip">
            {{ 'schedule.recordingSetup' | translate }} {{ 'is-required' | translate }}</div>
          }
        </label>
        @if (showSetupPreview) {
          <app-recording-setup-preview [setupPath]="recordingForm.get('recordingSetup').value?.path"></app-recording-setup-preview>
        }
      </div>
      @if (!internalVideoToolOnly && hasHudlAccount && videoTool === 'hudl') {
        <div class="mt-4 form-group">
          <label>{{ 'schedule.hudlEvent' | translate }}</label>&nbsp;@if (recordingForm.get('team').value !== null) {
          <button type="button" (click)="refreshHudlEvents()" class="btn no-padding iconsminds-repeat-2"></button>
        }
        <label class="w-100">
          <ng-select appearance="outline" [items]="hudlEvents" bindLabel="name" bindValue="id" [searchable]="false" [loading]="hudlEventsLoading" formControlName="hudlEvent">
            <ng-template ng-option-tmp let-item="item">
              <div>{{item.name}}</div>
              <small>{{item.time | date: 'yyyy-MM-dd'}}</small>
            </ng-template>
          </ng-select>
          @if (!recordingForm.get('hudlEvent').value && videoToolVersion === 'classic') {
            <alert type="warning">
              <strong>{{ 'schedule.hudlEmptyWarning' | translate }}</strong>
            </alert>
          }
          @if (recordingForm.get('hudlEvent').errors?.required && submitted) {
            <div class="invalid-tooltip">
            {{ 'schedule.hudlEvent' | translate }} {{ 'is-required' | translate }}</div>
          }
        </label>
      </div>
    }
    @if (!internalVideoToolOnly && showHudlCategory) {
      <div class="mt-4 form-group">
        <label>{{ 'schedule.hudlCategory' | translate }}</label>
        <label class="w-100">
          @for (hudlCategory of hudlCategories; track hudlCategory) {
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" formControlName="hudlCategory" [value]="hudlCategory.value">
                {{ hudlCategory.displayValue }}
              </label>
            </div>
          }
        </label>
      </div>
    }
    @if (!internalVideoToolOnly && hasVidswapAccount && videoTool === 'vidswap') {
      <div class="mt-4 form-group">
        <label>{{ 'schedule.vidswapType' | translate }}</label>
        <label class="w-100">
          @for (vidswapType of vidswapTypes; track vidswapType) {
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" formControlName="vidswapType" [value]="vidswapType.value">
                {{ vidswapType.displayValue }}
              </label>
            </div>
          }
        </label>
      </div>
    }
    @if (replayAvailable) {
      <div class="mt-4 form-group">
        <div class="custom-control custom-checkbox mb-4">
          <input type="checkbox" class="custom-control-input" formControlName="includeReplayEvent" id="includeReplayEvent">
          <label class="custom-control-label" for="includeReplayEvent">{{ 'schedule.includeReplayEvent' | translate }}</label>
        </div>
      </div>
    }
    @if (!internalVideoToolOnly && (!showHudlCategory || [4,5].indexOf(recordingForm.get('hudlCategory').value) > -1)) {
      <div class="mt-4 form-group">
        <div class="custom-control custom-checkbox mb-4">
          <input type="checkbox" class="custom-control-input" formControlName="liveBroadcast" id="liveBroadcast">
          @if (liveStreamProvider == 'youtube') {
            <label class="custom-control-label" for="liveBroadcast">{{ 'schedule.liveBroadcastYoutube' | translate }}</label>
          }
          @if (liveStreamProvider != 'youtube') {
            <label class="custom-control-label" for="liveBroadcast">{{ 'schedule.liveBroadcast' | translate }}</label>
          }
        </div>
      </div>
    }
    @if ((recordingForm.get('liveBroadcast').value && liveStreamProvider == 'youtube' && (!showHudlCategory || [4,5].indexOf(recordingForm.get('hudlCategory').value) > -1)) || videoTool === 'youtube' || internalVideoToolOnly) {
      <div class="mt-4 form-group">
        <label>{{ 'schedule.videoPrivacy' | translate }}</label>
        <label class="w-100">
          @for (privacyOption of privacyOptions; track privacyOption) {
            <div class="form-check">
              <label class="form-check-label">
                <input class="form-check-input" type="radio" formControlName="videoPrivacy" [value]="privacyOption.value">
                {{ privacyOption.displayValue | translate }}
              </label>
            </div>
          }
        </label>
      </div>
    }
    @if (!internalVideoToolOnly && (!showHudlCategory || [4,5].indexOf(recordingForm.get('hudlCategory').value) > -1)) {
      @if (recordingForm.get('liveBroadcast').value) {
        @if (liveStreamProvider == 'youtube') {
          <div class="mt-4 form-group">
            <label>{{ 'schedule.youtubeBroadcastKey' | translate }}</label>
            <label class="w-100">
              <input class="form-control" formControlName="youtubeBroadcastKey" />
            </label>
          </div>
        }
        @if (liveStreamProvider == 'rtmp') {
          <div class="mt-4 form-group">
            <label>{{ 'schedule.rtmpBroadcastLink' | translate }}</label>
            <label class="w-100">
              <input class="form-control" formControlName="rtmpBroadcastLink" />
            </label>
            @if (recordingForm.get('rtmpBroadcastLink').errors?.required && submitted) {
              <div class="invalid-tooltip">
              {{ 'schedule.rtmpBroadcastLink' | translate }} {{ 'is-required' | translate }}</div>
            }
          </div>
        }
        @if (team.isLocation) {
          <div class="mt-4 form-group">
            <label>{{ 'schedule.homeTeam' | translate }}</label>
            <label class="w-100">
              <ng-select appearance="outline" [items]="opponentTeams" [searchable]="true" bindLabel="displayValue" bindValue="path" formControlName="homeTeam" [loading]="opponentTeamsLoading">
                <ng-template ng-option-tmp let-item="item">
                  <div>{{ item.name }}</div>
                  <small>{{ item.organization.d }}</small>
                </ng-template>
              </ng-select>
            </label>
          </div>
        }
        <div class="mt-4 form-group">
          <label>{{ 'schedule.opponentTeam' | translate }}</label>
          <label class="w-100">
            <ng-select appearance="outline" [items]="opponentTeams" [searchable]="true" bindLabel="displayValue" bindValue="path" formControlName="opponentTeam" [loading]="opponentTeamsLoading">
              <ng-template ng-option-tmp let-item="item">
                <div>{{ item.name }}</div>
                <small>{{ item.organization.d }}</small>
              </ng-template>
            </ng-select>
          </label>
        </div>
      }
    }
    <div class="mt-4 form-group">
      <label>{{ 'schedule.date' | translate }}</label>
      <input type="text" [placeholder]="'schedule.datepickerPlaceholder' | translate" class="form-control" formControlName="date" bsDatepicker
        [container]="'html'" [bsConfig]="{ adaptivePosition: true, dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: false }"
        [minDate]="minDate">
        @if (recordingForm.get('date')?.errors?.required && submitted) {
          <div class="invalid-tooltip">
          {{ 'schedule.date' | translate }} {{ 'is-required' | translate }}</div>
        }
      </div>
      <div class="mt-4" formGroupName="dateSpan">
        <div class="row">
          <div class="col-xs-6 form-group">
            <label>{{ 'schedule.start-time' | translate }}</label>
            <timepicker class="timepicker" formControlName="start" [hourStep]="1" [minuteStep]="10"
            [showMeridian]="false" [mousewheel]="false" [showSpinners]="false"></timepicker>
            @if (recordingForm.get('dateSpan').get('start')?.errors?.required && submitted) {
              <div class="invalid-tooltip">
              {{ 'schedule.start-time' | translate }} {{ 'is-required' | translate }}</div>
            }
          </div>
          <div class="col-xs-6 form-group">
            <label>{{ 'schedule.end-time' | translate }}</label>
            <timepicker class="timepicker" formControlName="end" [hourStep]="1" [minuteStep]="10"
            [showMeridian]="false" [mousewheel]="false" [showSpinners]="false"></timepicker>
            @if (recordingForm.get('dateSpan').get('end')?.errors?.required && submitted) {
              <div class="invalid-tooltip">
              {{ 'schedule.endTimeRequired' | translate }}</div>
            }
            @if (recordingForm.get('dateSpan')?.errors?.dateMoreThan) {
              <div class="invalid-tooltip">
              {{ 'schedule.endTimeAfterStart' | translate }}</div>
            }
          </div>
        </div>
        @if (isPastDateTime) {
          <alert type="warning" class="d-block mt-3">{{ 'schedule.past-date-warning' | translate }}</alert>
        }
      </div>
      <div class="mt-4 form-group">
        <label>{{ 'schedule.eventName' | translate }}</label>
        <label class="w-100">
          <input class="form-control" formControlName="eventName" />
          @if (recordingForm.get('eventName').errors?.required && submitted) {
            <div class="invalid-tooltip">
            {{ 'schedule.eventName' | translate }} {{ 'is-required' | translate }}</div>
          }
        </label>
      </div>
      @if (!internalVideoToolOnly && hasHudlAccount && videoTool == 'hudl' && recordingForm.get('hudlEvent').value !== null) {
        <div class="mt-4 form-group">
          <label>{{ 'schedule.hudlShare' | translate }}</label>&nbsp;@if (recordingForm.get('team').value !== null) {
          <button type="button" (click)="refreshHudlMembersAndGroups()" class="btn no-padding iconsminds-repeat-2"></button>
        }
        <label class="w-100">
          <ng-select [loading]="hudlAvailableShareListLoading" [items]="hudlAvailableShareList" [hideSelected]="true" [multiple]="true" bindLabel="displayValue" bindValue="value" [closeOnSelect]="false" formControlName="hudlShare">
          </ng-select>
        </label>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <form class="d-flex justify-content-end align-items-center" [formGroup]="recordingForm" (ngSubmit)="onSubmit()">
    <button type="button" class="btn btn-outline-primary mr-1"
    (click)="modalRef.hide()">{{'modal.cancel' | translate }}</button>
    <button type="submit" class="btn btn-primary">{{ 'modal.submit' | translate}}</button>
  </form>
</div>
</ng-template>
